export default Object.freeze({
  REDIRECT: {
    LOGIN: '/auth/login/',
    LOGOUT: '/auth/logout/',
    LOGOUT_RETURN_TO: '/sensyn-id/logout/?redirect_app=datastore-v3',
    HOME: '/',
    CALLBACK: '/auth/callback',
    AUTH_ERROR: '/auth/error/',
  },
  TOKEN: {
    STORAGE_KEY: 'auth.access_token',
  },
});
